<template>
  <section id="about" class="product" data-scroll-section>
    <div class="l-container">
      <CSectionTitle textColor="red">
        <template v-slot:titleEn>
          ABOUT JET
        </template>
        <template v-slot:titleJa>
          ジェットについて
        </template>
        <template v-slot:bg>
          <svg
            class="tri"
            :class="{ 'in-view': inView }"
            width="970"
            height="719"
            viewBox="0 0 970 719"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <mask id="productTitleMask">
                <rect
                  class="mask-rect"
                  x="0"
                  y="0"
                  width="970"
                  height="719"
                  fill="white"
                />
              </mask>
            </defs>

            <path
              d="M970 0L183.053 111.167L0 719L970 0Z"
              fill="white"
              mask="url(#productTitleMask)"
            />
          </svg>
        </template>
      </CSectionTitle>

      <div class="intro__container">
        <div class="intro__col">
          <picture>
            <source type="image/webp" srcset="@/assets/bottle.webp" />
            <img
              data-scroll
              :data-scroll-speed="$store.state.isMobile ? -0.5 : -1"
              data-scroll-delay="0.05"
              class="intro__bottle"
              src="@/assets/bottle.png"
              alt=""
            />
          </picture>
          <svg
            data-scroll
            data-scroll-speed="1"
            data-scroll-delay="0.05"
            data-scroll-target="#about"
            class="bottle-tri"
            :class="{ 'in-view': inView }"
            width="518"
            height="490"
            viewBox="0 0 518 490"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <mask id="bottleMask">
                <rect class="mask-rect" x="0" y="0" width="618" height="690" />
              </mask>
            </defs>

            <path
              mask="url(#bottleMask)"
              d="M0 489.995L499.549 447.054L518 0.995178L0 489.995Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="intro__col">
          <h3 ref="copy" class="intro__col__copy">
            一度決めた立ち上がりを崩さず、<br />
            ハードな立体感を演出
          </h3>
          <div class="intro__col__body">
            <p class="intro__col__desc">
              トリコでは７つ目のワックス商品で、一番固いハードワックス「一度決めた立ち上がりを崩さず、ハードな立体感を演出。簡単スタイリングで速攻キマる。」が特徴となっている。
            </p>
            <div class="intro__rate-container">
              <div class="intro__rate-item">
                <span>セット力</span>
                <p>★★★★★★</p>
              </div>
              <div class="intro__rate-item">
                <span>ツヤ感</span>
                <p>★★★★☆</p>
              </div>
              <div class="intro__rate-item">
                <span>操作性</span>
                <p>★★★★☆</p>
              </div>
              <div class="intro__rate-item">
                <span>束感</span>
                <p>★★★★★★</p>
              </div>
            </div>
            <c-button
              color="white"
              :isShopButton="true"
              :onClick="onLinkClick"
            />
          </div>
        </div>
        <div class="intro__product-name-wrap">
          <h3
            data-scroll
            data-scroll-direction="horizontal"
            :data-scroll-speed="$store.state.isMobile ? 8 : 20"
            data-scroll-target="#about"
            class="intro__product-name"
          >
            TRICO JET
          </h3>
        </div>
      </div>
    </div>
    <svg
      class="tri tri-01"
      data-scroll
      :data-scroll-speed="$store.state.isMobile ? 2 : 4"
      data-scroll-delay="0.05"
      :data-scroll-direction="$store.state.isMobile ? `vertical` : `horizontal`"
      data-scroll-target="#about"
      width="606"
      height="718"
      viewBox="0 0 606 718"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#drop-shadow-01)">
        <path
          d="M82 635.21L523.72 635.209L542 82.1309L82 635.21Z"
          fill="#E40718"
          opacity="0.1"
        />
      </g>
      <path
        d="M82 635.21L523.72 635.209L542 82.1309L82 635.21Z"
        fill="#E40718"
      />
      <defs>
        <filter id="drop-shadow-01">
          <feGaussianBlur in="SourceAlpha" stdDeviation="32"></feGaussianBlur>
          <feOffset dx="0" dy="-10" />
        </filter>
      </defs>
    </svg>

    <svg
      class="tri tri-02"
      :class="{ 'in-view': inView }"
      data-scroll
      data-scroll-speed="3"
      data-scroll-delay="0.5"
      data-scroll-direction="horizontal"
      data-scroll-target="#about"
      width="922"
      height="851"
      viewBox="0 0 922 851"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#drop-shadow-02)">
        <path
          d="M82 768.106L823 690.5L902.5 82.1064L82 768.106Z"
          fill="#E40718"
          opacity="0.15"
        />
      </g>
      <path
        d="M82 768.106L823 690.5L902.5 82.1064L82 768.106Z"
        fill="#E40718"
      />
      <defs>
        <filter id="drop-shadow-02">
          <feGaussianBlur in="SourceAlpha" stdDeviation="32"></feGaussianBlur>
          <feOffset dx="-30" dy="-10" />
        </filter>
      </defs>
    </svg>
  </section>
</template>

<script>
import CButton from '@/components/C-Button.vue'
import CSectionTitle from '@/components/C-SectionTitle.vue'

import scrollTrigger from '@/mixins/scrollTrigger.js'

import 'splitting/dist/splitting.css'
import 'splitting/dist/splitting-cells.css'
import Splitting from 'splitting'
import gsap from 'gsap'

export default {
  mixins: [scrollTrigger],

  components: { CButton, CSectionTitle },

  data() {
    return {
      inView: false
    }
  },

  async mounted() {
    const { state } = this.$store
    const copy = this.$refs.copy
    await Splitting({
      target: copy,
      by: 'chars'
    })

    const tl = gsap.timeline({ paused: true })
    tl.add(function() {
      copy.classList.add('in-view')
    })
    tl.to(copy.querySelectorAll('.char'), {
      y: 0,
      duration: 0.8,
      stagger: 0.014,
      delay: 0.05,
      ease: 'Power3.easeOut'
    })

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            tl.play()
            this.inView = true

            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: state.isMobile ? 0.0 : 0.2 }
    )

    observer.observe(copy)
  },

  methods: {
    onLinkClick() {
      window.location.href = 'https://oceantrico.com/product/jet'
    }
  }
}
</script>

<style lang="scss" scoped>
.product {
  position: relative;
  padding: 12rem 0 0;
  z-index: 0;
  @media screen and (max-width: $breakpoint-mobile) {
    padding: 12rem 0 6rem;
  }
  .c-section-title {
    position: relative;

    .tri {
      position: absolute;
      width: 120rem;
      top: -12vw;
      left: -15vw;
      z-index: -9;
      @media screen and (max-width: $breakpoint-mobile) {
        width: 100rem;
        top: -14rem;
        left: -40rem;
      }

      .mask-rect {
        transform: translate3d(-100%, 0, 0) rotate(16deg);
        transform-origin: 50% 50%;
        fill: #fff;
        @keyframes title-mask-anim {
          0% {
            transform: translate3d(-100%, 0, 0) rotate(16deg);
          }

          100% {
            transform: translate3d(0%, 0, 0) rotate(0deg);
          }
        }
      }

      &.in-view {
        .mask-rect {
          animation: title-mask-anim 1.2s $easeInOutQuint;
          transform: translate3d(0%, 0%, 0) rotate(0deg);
          @media screen and (max-width: $breakpoint-mobile) {
            animation: title-mask-anim 1.1s $easeOutQuint;
          }
        }
      }
    }
  }
  .intro {
    &__container {
      position: relative;
      display: flex;
      z-index: 0;

      @media screen and (max-width: $breakpoint-mobile) {
        flex-direction: column;
      }
    }

    &__bottle {
      will-change: transform;
      backface-visibility: hidden;
      @media screen and (max-width: $breakpoint-mobile) {
        width: 24rem;
        margin: 0 0 5rem;
      }
    }

    &__col {
      position: relative;
      width: 50%;
      @media screen and (max-width: $breakpoint-mobile) {
        width: 100%;
      }
      &__copy {
        font-size: 4rem;
        text-align: left;
        margin: 0 0 4rem;
        padding: 0 3rem;
        transform: skewY(-5deg);
        color: #fff;
        line-height: 1.65;
        white-space: nowrap;
        @media screen and (max-width: $breakpoint-mobile) {
          font-size: 2.4rem;
          padding: 0;
        }

        ::v-deep .word {
          overflow: hidden;
        }

        ::v-deep .char {
          transform: translate3d(0%, 100%, 0);
        }
      }

      &__body {
        padding: 0 8rem;
        @media screen and (max-width: $breakpoint-mobile) {
          padding: 0;
        }
      }

      &__desc {
        text-align: left;
        font-size: 1.8rem;
        font-weight: 600;
        margin: 0 0 3rem;
        color: #fff;
        @media screen and (max-width: $breakpoint-mobile) {
          font-size: 1.4rem;
        }
      }

      .bottle-tri {
        position: absolute;
        width: 64rem;
        right: 6rem;
        z-index: -9;
        @media screen and (max-width: $breakpoint-mobile) {
          right: -10rem;
          width: 34rem;
          top: -12rem;
          z-index: -9;
        }

        .mask-rect {
          transform: translate3d(120%, -25%, 0) rotate(16deg);
          // animation: mask-anim 3s $easeInOutQuint infinite;
          transform-origin: 50% 50%;
          fill: #fff;
          @keyframes mask-anim {
            0% {
              transform: translate3d(120%, -25%, 0) rotate(16deg);
            }

            100% {
              transform: translate3d(0%, -25%, 0) rotate(0deg);
            }
          }
        }

        &.in-view {
          .mask-rect {
            animation: mask-anim 1.25s $easeInOutQuint;
            transform: translate3d(0%, -25%, 0) rotate(0deg);
            @media screen and (max-width: $breakpoint-mobile) {
              animation: mask-anim 1.45s $easeOutQuint;
            }
          }
        }
      }
    }

    &__rate-container {
      display: flex;
      flex-wrap: wrap;
      background: #ffffff;
      box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.09);
      margin: 0 0 3rem;
    }

    &__rate-item {
      width: 50%;
      text-align: left;
      padding: 1.6rem 2.4rem;
      color: var(--main-color);

      span {
        display: inline-block;
        padding: 0 0 0.5rem;
        font-size: 1.2rem;
        font-weight: 600;
        line-height: 1;
      }

      p {
        font-size: 1.8rem;
        font-weight: 800;
      }
    }

    &__mapping-container {
      font-size: 1.3rem;
      p {
        margin: 0 0 1.4rem;
      }
    }

    &__product-name-wrap {
      position: absolute;
      top: 0;
      left: 0;
      transform: translate3d(-50rem, 4.5rem, 0) skewY(-8deg);
      z-index: -9;
    }

    &__product-name {
      font-size: 30rem;
      white-space: nowrap;
      opacity: 0.06;
      will-change: transform;
      backface-visibility: hidden;
    }
  }

  .tri {
    position: absolute;
    top: 0;
    z-index: -9;
    will-change: transform;
    backface-visibility: hidden;
    &.tri-01 {
      top: 7rem;
      right: -10rem;
    }
    &.tri-02 {
      top: -30rem;
    }
  }
}
</style>
